/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-11-12 17:10:26
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-09-14 13:51:29
 * @FilePath     : /marketing-introduce-ssr/components/Activity/TipsPopup/index.tsx
 * @Description  : 未添加文件描述
 */
import { Modal } from 'antd-mobile';
import React from 'react';

import styles from './index.module.scss';

function closest(el: any, selector: string) {
  const matchesSelector =
    el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
  let currentEl = el; // 使用局部变量代替直接修改参数
  while (currentEl) {
    if (matchesSelector.call(currentEl, selector)) {
      return currentEl;
    }
    currentEl = currentEl.parentElement;
  }
  return null;
}

const onWrapTouchStart = (e: any) => {
  // fix touch to scroll background page on iOS
  if (!/iPhone|iPod|iPad/i.test(navigator.userAgent)) {
    return;
  }
  const pNode = closest(e.target, '.am-modal-content');
  if (!pNode) {
    e.preventDefault();
  }
};

interface IProps {
  children: JSX.Element | string;
  onClose?: () => void;
  onConfirm?: () => void;
  visible: boolean;
  btnText?: string;
  subTitle?: string;
  showBtn?: boolean;
  title?: string | JSX.Element;
}

const TipsPopup = React.memo(
  ({
    title = '温馨提示',
    children,
    visible,
    btnText = '我知道啦',
    subTitle = '',
    showBtn = true,
    onClose,
    onConfirm
  }: IProps): JSX.Element => {
    return (
      <Modal
        visible={visible}
        className={styles.modal}
        style={{
          width: '6.7rem'
        }}
        closable={Boolean(onClose)}
        transparent
        maskClosable={false}
        onClose={onClose}
        title={
          subTitle ? (
            <>
              {title}
              <br />
              <span className={styles['sub-title']}>{subTitle}</span>
            </>
          ) : (
            title
          )
        }
        wrapProps={{ onTouchStart: onWrapTouchStart }}>
        <>
          <div className={styles.text}>{children}</div>

          {showBtn ? (
            <button type='button' onClick={onConfirm || onClose} className={styles.btn}>
              {btnText}
            </button>
          ) : null}
        </>
      </Modal>
    );
  }
);

export { TipsPopup };
